export default [
    {
        path: 'relatorio-alto-custo-processo',
        component: () => import(
            /* webpackChunkName: 'farmacia-relatorio-alto-custo-processo' */
            '@/views/farmacia/relatorio-alto-custo-processo/Index'
        ),
        redirect: 'relatorio-alto-custo-processo/index',
        children: [
            {
                name: 'farmacia-relatorio-alto-custo-processo-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'farmacia-relatorio-alto-custo-processo' */
                    '@/views/farmacia/relatorio-alto-custo-processo/List.vue'
                ),
            },
        ],
    },
]